import React from "react";

import { Item, Root, type ToggleGroupItemProps } from "@radix-ui/react-toggle-group";

import styles from "./ToggleGroup.module.css";

type ToggleGroupRootProps = React.ComponentProps<typeof Root>;

export function ToggleGroupRoot({ children, ...props }: ToggleGroupRootProps) {
	return (
		<Root {...props} className={styles.root}>
			{children}
		</Root>
	);
}

export const ToggleGroupItem = React.forwardRef<HTMLButtonElement, ToggleGroupItemProps>(
	({ children, ...props }, ref) => {
		return (
			<Item {...props} ref={ref} className={styles.item}>
				{children}
			</Item>
		);
	},
);

ToggleGroupItem.displayName = "ToggleGroupItem";
